import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'WAM_COMPACT_TABLES';

const UiPreferencesContext = createContext({
  compactTables: false,
  toggleCompactTables: () => {},
  setCompactTables: () => {},
});

export const UiPreferencesProvider = ({ children }) => {
  const [compactTables, setCompactTables] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }
    document.body?.setAttribute('data-compact-tables', compactTables ? '1' : '0');
    return () => {
      document.body?.removeAttribute('data-compact-tables');
    };
  }, [compactTables]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.setItem(STORAGE_KEY, compactTables ? '1' : '0');
    } catch {
      /* noop */
    }
  }, [compactTables]);

  const toggleCompactTables = useCallback(() => {
    setCompactTables((prev) => !prev);
  }, []);

  const value = useMemo(
    () => ({
      compactTables,
      toggleCompactTables,
      setCompactTables,
    }),
    [compactTables, toggleCompactTables]
  );

  return <UiPreferencesContext.Provider value={value}>{children}</UiPreferencesContext.Provider>;
};

export const useUiPreferences = () => useContext(UiPreferencesContext);

